import React from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend
} from "recharts";

function DarkTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;

  return (
    <div
      style={{
        background: "rgba(5,12,24,0.96)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 12,
        padding: "10px 12px",
        boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
        color: "#fff",
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 6 }}>{label}</div>
      {payload.map((entry, idx) => (
        <div key={idx} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginTop: 3 }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: entry.color, display: "inline-block" }} />
          <span style={{ opacity: 0.82 }}>{entry.name}</span>
          <span style={{ fontWeight: 800 }}>{entry.value}</span>
        </div>
      ))}
    </div>
  );
}

export default function StaffActivityChart({ data = [], title = "Live Operations Snapshot", subtitle = "" }) {
  return (
    <div
      style={{
        background: "linear-gradient(180deg, rgba(10,24,54,0.96), rgba(5,14,33,0.96))",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 18,
        padding: 16,
        minHeight: 340,
      }}
    >
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: "#fff" }}>{title}</div>
        {subtitle ? <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>{subtitle}</div> : null}
      </div>

      <ResponsiveContainer width="100%" height={270}>
        <LineChart data={data} margin={{ top: 12, right: 14, bottom: 0, left: -18 }}>
          <CartesianGrid stroke="rgba(148,163,184,0.10)" vertical={false} />
          <XAxis dataKey="label" stroke="#9fb2ce" tickLine={false} axisLine={false} />
          <YAxis stroke="#9fb2ce" tickLine={false} axisLine={false} allowDecimals={false} />
          <Tooltip content={<DarkTooltip />} />
          <Legend />
          <Line type="monotone" dataKey="today" name="today" stroke="#47d7f4" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 6 }} />
          <Line type="monotone" dataKey="yesterday" name="yesterday" stroke="#aab6c9" strokeWidth={2.2} dot={{ r: 3 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
